import React, { useState, useEffect, useRef, useCallback } from 'react';

function Footer() {
    const [viewsCount, setViewsCount] = useState('...');
    const [visitsCount, setVisitsCount] = useState('...');
    const [currentYear] = useState(new Date().getFullYear());
    
    // Ref to prevent double-calling in React StrictMode
    const isFirstRender = useRef(true);

    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

    const updateCounter = useCallback(async () => {
        try {
            // Check if this is a new session (unique visit)
            const isNewVisit = sessionStorage.getItem('hasVisited') === null;
            
            console.log('📊 Counter Debug:', {
                API_URL,
                isNewVisit,
                sessionStorageValue: sessionStorage.getItem('hasVisited')
            });

            const url = `${API_URL}/counter?newVisit=${isNewVisit}`;
            console.log('🌐 Fetching:', url);

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            
            console.log('📡 Response status:', response.status);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log('📦 Response data:', data);

            if (data.success) {
                setViewsCount(data.views);
                setVisitsCount(data.visits);
                
                // Mark session as visited AFTER successful API call
                if (isNewVisit) {
                    sessionStorage.setItem('hasVisited', 'true');
                    console.log('✅ Session marked as visited');
                }
            } else {
                throw new Error(data.message || 'Counter update failed');
            }
        } catch (error) {
            console.error('❌ Counter fetch error:', error);
            setViewsCount('N/A');
            setVisitsCount('N/A');
        }
    }, [API_URL]);

    useEffect(() => {
        // Prevent double-call in React StrictMode (development)
        if (!isFirstRender.current) {
            console.log('⏭️ Skipping duplicate call (StrictMode)');
            return;
        }
        isFirstRender.current = false;
        
        console.log('🚀 Footer mounted, calling counter API...');
        updateCounter();
    }, [updateCounter]);

    const scrollToTop = (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="counter">
                    <h2>Views: <span>{viewsCount}</span></h2>
                    <h2>Visits: <span>{visitsCount}</span></h2>
                </div>
                <div className="mid-footer">
                    <div 
                        className="footer-iconTop" 
                        onClick={scrollToTop} 
                        role="button" 
                        tabIndex={0} 
                        aria-label="Scroll to top"
                        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && scrollToTop(e)}
                    >
                        <a href="#home" onClick={scrollToTop} aria-label="Back to top">
                            <i className='bx bx-chevron-up'></i>
                        </a>
                    </div>
                    <div className="footer-text">
                        <p>Copyright &copy; {currentYear} by Rastra D. Karki | All Rights Reserved.</p>
                    </div>
                    <div className="footer-social">
                        <a 
                            href="https://github.com/Rastra17" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            aria-label="GitHub Profile"
                            title="GitHub"
                        >
                            <i className='bx bxl-github'></i>
                        </a>
                        <a 
                            href="https://www.linkedin.com/in/rastrakarki/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            aria-label="LinkedIn Profile"
                            title="LinkedIn"
                        >
                            <i className='bx bxl-linkedin-square'></i>
                        </a>
                        <a 
                            href="https://www.facebook.com/rastrakarki" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            aria-label="Facebook Page"
                            title="Facebook"
                        >
                            <i className='bx bxl-facebook-circle'></i>
                        </a>
                        <a 
                            href="mailto:rastradhoj@gmail.com"
                            aria-label="Email Me"
                            title="Email"
                        >
                            <i className='bx bxl-gmail'></i>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;